/**
 * Ajax Loading JS Class
 * @package campbellau
 */

class AjaxLoader {
				
	constructor(
		{
			filterData = null,
		} = {}					
		) {

		this.filterData = filterData;
	}
	
	load() {

        return jQuery.ajax({
			url : frontend_ajax.ajaxurl,
			data : this.filterData, // form data
			dataType : 'json', // this data type allows us to receive objects from the server
			type : 'POST',
		});
    }
}